/* Reyform : circuitanimatie in het hero-vlak. Canvas 2D, één renderlus. */
(function () {
  "use strict";
  var canvas = document.querySelector("[data-hero-canvas]");
  if (!canvas) return;
  var ctx = canvas.getContext("2d");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var BLUE = "0,144,227", GREEN = "0,185,0", ICE = "150,205,240";
  var PITCH = 76, RADIUS = 18, STEPS = 22, FXK = 0.62;
  var LAYERS = [
    { depth: 0, width: 0.7, line: 0.09, speed: 0.62, bright: 0.5 },
    { depth: 1, width: 1.0, line: 0.15, speed: 0.9, bright: 0.8 },
    { depth: 2, width: 1.45, line: 0.22, speed: 1.25, bright: 1 }
  ];
  var w = 0, h = 0, dpr = 1, paths = [], base = null, last = 0, sparks = [];
  var fx = document.createElement("canvas"), fxc = fx.getContext("2d");
  var bloom = document.createElement("canvas"), bc = bloom.getContext("2d");
  var lite = false, ema = 10;

  function sprite(rgb, size) {
    var c = document.createElement("canvas");
    c.width = c.height = size;
    var g = c.getContext("2d"), r = size / 2;
    var rg = g.createRadialGradient(r, r, 0, r, r, r);
    rg.addColorStop(0, "rgba(" + rgb + ",0.55)");
    rg.addColorStop(0.35, "rgba(" + rgb + ",0.16)");
    rg.addColorStop(1, "rgba(" + rgb + ",0)");
    g.fillStyle = rg; g.fillRect(0, 0, size, size);
    return c;
  }
  var glow = { blue: sprite(BLUE, 96), green: sprite(GREEN, 96) };
  var QL = 14, QS = 16, tailA = {}, sparkA = {}, headA = new Array(QL + 1);
  ["blue", "green"].forEach(function (key) {
    var rgb = key === "green" ? GREEN : BLUE, rows = [], j, q;
    for (j = 0; j < STEPS; j++) {
      var k = (j + 1) / STEPS, row = new Array(QL + 1);
      for (q = 0; q <= QL; q++) row[q] = "rgba(" + rgb + "," + (0.44 * Math.pow(k, 2.1) * (q / QL)).toFixed(3) + ")";
      rows.push(row);
    }
    tailA[key] = rows;
    var sr = new Array(QS + 1);
    for (q = 0; q <= QS; q++) sr[q] = "rgba(" + rgb + "," + (0.3 * Math.pow(1 - q / QS, 2.4)).toFixed(3) + ")";
    sparkA[key] = sr;
  });
  for (var hq = 0; hq <= QL; hq++) headA[hq] = "rgba(244,251,255," + (0.55 + (hq / QL) * 0.42).toFixed(3) + ")";

  function densify(pts) {
    var out = [pts[0]];
    for (var i = 1; i < pts.length - 1; i++) {
      var p = pts[i - 1], c = pts[i], n = pts[i + 1];
      var d1 = Math.hypot(c.x - p.x, c.y - p.y), d2 = Math.hypot(n.x - c.x, n.y - c.y);
      if (d1 < 2 || d2 < 2) continue;
      var r = Math.min(RADIUS, d1 / 2, d2 / 2);
      var a = { x: c.x - ((c.x - p.x) / d1) * r, y: c.y - ((c.y - p.y) / d1) * r };
      var b = { x: c.x + ((n.x - c.x) / d2) * r, y: c.y + ((n.y - c.y) / d2) * r };
      out.push(a);
      for (var t = 1; t <= 6; t++) {
        var u = t / 7, iu = 1 - u;
        out.push({ x: iu * iu * a.x + 2 * iu * u * c.x + u * u * b.x, y: iu * iu * a.y + 2 * iu * u * c.y + u * u * b.y });
      }
      out.push(b);
    }
    out.push(pts[pts.length - 1]);
    return out;
  }

  function pointAt(p, d, out) {
    var rest = d < 0 ? 0 : d, segs = p.segs;
    for (var i = 0; i < segs.length; i++) {
      var sg = segs[i];
      if (rest <= sg.len) {
        var r = rest / sg.len;
        out.x = sg.x1 + (sg.x2 - sg.x1) * r;
        out.y = sg.y1 + (sg.y2 - sg.y1) * r;
        return out;
      }
      rest -= sg.len;
    }
    var l = segs[segs.length - 1];
    out.x = l.x2; out.y = l.y2;
    return out;
  }

  function finish(raw, layer, color) {
    if (Math.random() < 0.5) raw.reverse();
    var pts = densify(raw), segs = [], total = 0;
    for (var i = 1; i < pts.length; i++) {
      var len = Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y);
      if (len < 0.5) continue;
      segs.push({ x1: pts[i - 1].x, y1: pts[i - 1].y, x2: pts[i].x, y2: pts[i].y, len: len });
      total += len;
    }
    if (!segs.length) return null;
    return {
      pts: pts, segs: segs, total: total, layer: layer, color: color,
      nodes: raw.slice(1, -1).map(function (n) { return { x: n.x, y: n.y, hit: -1 }; }),
      speed: (42 + Math.random() * 26) * layer.speed,
      offset: Math.random() * total,
      tail: 190 + Math.random() * 110
    };
  }

  function build() {
    paths = []; sparks = [];
    var lanes = Math.min(14, Math.max(7, Math.round(h / PITCH)));
    var spacing = h / lanes, n, raw, x, y, guard, dir, ny, nx, laneY, laneX, band;
    for (n = 0; n < lanes; n++) {
      laneY = spacing * (n + 0.5); band = spacing * 0.6;
      raw = []; x = -PITCH * (1 + Math.random()); y = laneY; raw.push({ x: x, y: y }); guard = 0;
      while (x < w + PITCH * 2 && guard++ < 26) {
        x += PITCH * (0.7 + Math.random() * 1.1);
        raw.push({ x: x, y: y });
        dir = y > laneY ? (Math.random() < 0.7 ? -1 : 1) : (Math.random() < 0.7 ? 1 : -1);
        ny = y + dir * PITCH * (Math.random() < 0.55 ? 0.5 : 1);
        if (ny > 20 && ny < h - 20 && Math.abs(ny - laneY) <= band) { y = ny; raw.push({ x: x, y: y }); }
      }
      var p1 = finish(raw, LAYERS[n % 3], n % 5 === 2 ? "green" : "blue");
      if (p1) paths.push(p1);
    }
    var cols = Math.min(10, Math.max(4, Math.round(w / PITCH / 2.2)));
    var cspacing = w / cols;
    for (n = 0; n < cols; n++) {
      laneX = cspacing * (n + 0.5); band = cspacing * 0.4;
      raw = []; y = -PITCH * (1 + Math.random()); x = laneX; raw.push({ x: x, y: y }); guard = 0;
      while (y < h + PITCH * 2 && guard++ < 22) {
        y += PITCH * (0.7 + Math.random() * 1.1);
        raw.push({ x: x, y: y });
        dir = x > laneX ? (Math.random() < 0.7 ? -1 : 1) : (Math.random() < 0.7 ? 1 : -1);
        nx = x + dir * PITCH * (Math.random() < 0.55 ? 0.5 : 1);
        if (nx > 20 && nx < w - 20 && Math.abs(nx - laneX) <= band) { x = nx; raw.push({ x: x, y: y }); }
      }
      var p2 = finish(raw, LAYERS[(n + 1) % 3], n % 4 === 1 ? "green" : "blue");
      if (p2) paths.push(p2);
    }

    base = document.createElement("canvas");
    base.width = Math.round(w * dpr);
    base.height = Math.round(h * dpr);
    var b = base.getContext("2d");
    b.setTransform(dpr, 0, 0, dpr, 0, 0);
    b.lineJoin = "round"; b.lineCap = "round";
    for (var gx = PITCH / 2; gx < w; gx += PITCH / 2) {
      for (var gy = PITCH / 2; gy < h; gy += PITCH / 2) {
        var near = 1 - Math.min(1, Math.abs(gy - h / 2) / (h / 2));
        b.fillStyle = "rgba(" + ICE + "," + (0.05 + near * 0.05).toFixed(3) + ")";
        b.beginPath(); b.arc(gx, gy, 0.75, 0, 6.2832); b.fill();
      }
    }
    paths.forEach(function (p) {
      b.strokeStyle = "rgba(" + ICE + "," + p.layer.line.toFixed(3) + ")";
      b.lineWidth = p.layer.width;
      b.beginPath();
      b.moveTo(p.pts[0].x, p.pts[0].y);
      for (var i = 1; i < p.pts.length; i++) b.lineTo(p.pts[i].x, p.pts[i].y);
      b.stroke();
    });
  }

  function resize() {
    var r = canvas.getBoundingClientRect();
    if (!r.width || !r.height) return;
    dpr = Math.min(1.5, window.devicePixelRatio || 1);
    w = r.width; h = r.height;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    fx.width = Math.max(1, Math.round(w * FXK));
    fx.height = Math.max(1, Math.round(h * FXK));
    bloom.width = Math.max(1, Math.round(w * FXK * 0.5));
    bloom.height = Math.max(1, Math.round(h * FXK * 0.5));
    build();
  }

  var a = { x: 0, y: 0 }, bp = { x: 0, y: 0 };
  var raf = null;
  function draw(t) {
    if (!reduce) raf = requestAnimationFrame(draw);
    if (t - last < 13) return;
    var t0 = performance.now();
    var dt = Math.min(34, t - last);
    last = t;

    fxc.setTransform(FXK, 0, 0, FXK, 0, 0);
    fxc.clearRect(0, 0, w, h);
    fxc.globalCompositeOperation = "lighter";
    fxc.lineCap = "round"; fxc.lineJoin = "round";

    var secs = t / 1000, heads = [], stride = lite ? 2 : 1;
    paths.forEach(function (p) {
      var head = (p.offset + secs * p.speed) % (p.total + 340);
      var fade = Math.min(1, head / 90) * Math.min(1, (p.total + 60 - head) / 120);
      if (fade <= 0.01) return;
      var bright = p.layer.bright * fade, alphas = tailA[p.color], q = (bright * QL) | 0;
      for (var i = STEPS, j = 0; i > 0; i -= stride, j += stride) {
        pointAt(p, head - (p.tail * i) / STEPS, a);
        pointAt(p, head - (p.tail * (i - stride)) / STEPS, bp);
        fxc.strokeStyle = alphas[j][q];
        fxc.lineWidth = (0.35 + Math.pow(j / STEPS, 1.5) * 2.1) * (0.82 + p.layer.depth * 0.16);
        fxc.beginPath(); fxc.moveTo(a.x, a.y); fxc.lineTo(bp.x, bp.y); fxc.stroke();
      }
      if (head <= p.total) {
        pointAt(p, head, a);
        pointAt(p, head - 26, bp);
        fxc.strokeStyle = "rgba(" + ICE + "," + (0.34 * bright).toFixed(3) + ")";
        fxc.lineWidth = 0.85;
        fxc.beginPath(); fxc.moveTo(bp.x, bp.y); fxc.lineTo(a.x, a.y); fxc.stroke();
        var size = 76 + p.layer.depth * 14;
        fxc.globalAlpha = 0.42 + bright * 0.44;
        fxc.drawImage(glow[p.color], a.x - size / 2, a.y - size / 2, size, size);
        fxc.globalAlpha = 1;
        heads.push({ x: a.x, y: a.y, r: 1.5 + p.layer.depth * 0.35, bright: bright });
        p.nodes.forEach(function (nd) {
          var ndx = nd.x - a.x, ndy = nd.y - a.y;
          if (ndx * ndx + ndy * ndy < 49 && t - nd.hit > 900) {
            nd.hit = t;
            sparks.push({ x: nd.x, y: nd.y, life: 0, color: p.color, scale: 1 + p.layer.depth * 0.3 });
          }
        });
      }
    });

    for (var s = sparks.length - 1; s >= 0; s--) {
      var sp = sparks[s];
      sp.life += dt;
      var k = sp.life / 620;
      if (k >= 1) { sparks.splice(s, 1); continue; }
      var ease = 1 - Math.pow(1 - k, 2.2);
      fxc.strokeStyle = sparkA[sp.color][(k * QS) | 0];
      fxc.lineWidth = 0.9 * (1 - k) + 0.2;
      fxc.beginPath(); fxc.arc(sp.x, sp.y, (2 + ease * 21) * sp.scale, 0, 6.2832); fxc.stroke();
    }

    ctx.clearRect(0, 0, w, h);
    if (base) ctx.drawImage(base, 0, 0, w, h);
    ctx.save();
    ctx.globalCompositeOperation = "lighter";
    if (!lite) {
      bc.globalCompositeOperation = "copy";
      bc.drawImage(fx, 0, 0, bloom.width, bloom.height);
      ctx.globalAlpha = 0.9;
      ctx.drawImage(bloom, 0, 0, w, h);
      ctx.globalAlpha = 1;
    }
    ctx.drawImage(fx, 0, 0, w, h);
    heads.forEach(function (hd) {
      ctx.fillStyle = headA[(hd.bright * QL) | 0];
      ctx.beginPath(); ctx.arc(hd.x, hd.y, hd.r, 0, 6.2832); ctx.fill();
    });
    ctx.restore();

    var cost = performance.now() - t0;
    ema += (cost - ema) * 0.08;
    if (!lite && ema > 11) lite = true;
    else if (lite && ema < 5) lite = false;
  }

  resize();
  if (window.ResizeObserver) new ResizeObserver(resize).observe(canvas);
  else window.addEventListener("resize", resize);

  /* stil zetten als het vlak buiten beeld is of het tabblad op de achtergrond staat */
  var visible = true, awake = true;
  function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
  function play() {
    if (reduce || raf || !visible || !awake) return;
    last = performance.now() - 16;
    draw(performance.now());
  }
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      visible ? play() : stop();
    }, { threshold: 0 }).observe(canvas);
  }
  document.addEventListener("visibilitychange", function () {
    awake = !document.hidden;
    awake ? play() : stop();
  });

  last = performance.now() - 16;
  draw(performance.now());
})();
